// extracted by mini-css-extract-plugin
export default {"root":"n9m6L"};